module.exports = __webpack_public_path__ + "static/media/3.8ab59e7c.jpg";